function reload_room_checkers(elm, except) {
    const $ = jQuery.noConflict();
    const wrapper = elm.find('.course-components-appointments-wrapper');


    const checkRooms = function() {
        const fieldset = $(this).parents('fieldset');
        const dateFromInput = $(fieldset.find('input[name*="start_datetime"]')[0]);
        const timeFromInput = $(fieldset.find('input[name*="start_datetime"]')[1]);
        const dateToInput = $(fieldset.find('input[name*="end_datetime"]')[0]);
        const timeToInput = $(fieldset.find('input[name*="end_datetime"]')[1]);
        const roomInput = fieldset.find('select[name*="room_id"]');

        const dateFrom = dateFromInput.val();
        const timeFrom = timeFromInput.val();
        const dateTo = dateToInput.val();
        const timeTo = timeToInput.val();
        const room = parseInt(roomInput.val());

        if (fieldset.parent().find('input[name*="id"][value]')) {
            except = fieldset.parent().find('input[name*="id"][value]').val();
        }

        if (room > 0) {
            elm.isLoading();
            // Check availability
            $.getJSON('/rooms/getAvailability/' + room, {
                from: dateFrom + ' ' + timeFrom,
                to: dateTo + ' ' + timeTo,
                except
            }, function(data) {
                elm.doneLoading();

                if (data.length > 0) {
                    const roomDescription = roomInput.find('option[value="' + room + '"]').html();
                    const html = $('<div />');

                    html.html('<p class="callout warning"><em>' + roomDescription + '</em> is bezet op de volgende planningen.</p><div class="text-center"><button class="button primary">Sluiten</button></div>');

                    const table = $('<table class="scrollable=table" />');
                    data.forEach(function(row) {
                        table.append('<tr><td>' + row.description + '</td><td><a href="#" onclick="return view_appointment(' + row.id + ');" title="Openen"><span class="visual-icon-spyglass"></span></a></td></tr>');
                    });
                    html.find('p:first').after(table);

                    foundationPopup(html.html(), function(elm, popup) {
                        elm.find('button').click(function() {
                            popup.close();
                        });
                    }, 'tiny');
                }
            });
        }
    };

    wrapper.find('select[name*="room_id"]').change(checkRooms);
}
